// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"642":"1d9f0801","788":"1416134c","873":"8308f50c"}[chunkId] + ".chunk.css";
};